import CloseCircleIcon from '@material-ui/icons/CancelSharp';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import {Grid, makeStyles, Box, Paper, Typography} from "@material-ui/core";

import DontOverExposeImage from '../assets/guildeline_images/dont_overexpose.png'
import DontUnderExposeImage from '../assets/guildeline_images/dont_underexpose.png'
import DontBlurImage from '../assets/guildeline_images/dont_blur.png'
import DontSelfieImage from '../assets/guildeline_images/dont_selfie.png'
import DoWellExposeImage from '../assets/guildeline_images/do_properexpose.png';
import DoClearImage from '../assets/guildeline_images/do_clear.png';
import DoBalanceImage from '../assets/guildeline_images/do_balance.png'

const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
        '& .MuiTypography-h5': {
            textAlign: 'center',
            fontWeight: 500,
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: '100%',
        },
        '& img': {
            height: 150,
            width: 150,
            borderRadius: 4,
        },
        '& .MuiPaper-root': {
            '& .MuiTypography-h6': {
                marginBottom: theme.spacing(0.5),
            },
            boxShadow: '0 0 4px #000',
            padding: theme.spacing(1),
            margin: theme.spacing(1),
            textAlign: 'center',
            '& .MuiBox-root': {
                display: 'flex',
                padding: theme.spacing(0.5),
                width: '100%',
                alignItems: 'center',
                justifyContent: 'center',
                '& > img': {
                    marginLeft: 16,
                },
                '& .MuiTypography-root': {
                    textAlign: 'left',
                    maxWidth: 500,

                }
            }
        }
    }
}))

export default function DosAndDonts() {
    const classes = useStyles();
    return (
        <Box className={classes.root}>
            <Grid container spacing={1}>
                <Grid item xs={6}>
                    <Typography variant="h5">
                        <CheckCircleIcon style={{color: "#01ae01", marginRight: 16, fontSize: '1.5rem'}} />
                        DO'S
                    </Typography>
                </Grid>
                <Grid item xs={6}>
                    <Typography variant="h5">
                        <CloseCircleIcon style={{color: "red", marginRight: 16, fontSize: '1.5rem'}} />
                        DON'TS
                    </Typography>
                </Grid>
            </Grid>
            <Paper>
                <Grid container spacing={1}>
                    <Grid item xs={6} style={{display: 'flex', flexDirection: 'column'}}>
                        <Typography variant="h6">Well Exposed Pictures</Typography>
                        <Box style={{flex: '1'}}>
                            <img src={DoWellExposeImage} alt="do well expose" />
                        </Box>
                    </Grid>
                    <Grid item xs={6}>
                        <Typography variant="h6">Over or Under Exposed Pictures</Typography>
                        <Box>
                            <img src={DontOverExposeImage} alt='a' />
                            <img src={DontUnderExposeImage} alt="dont" />
                        </Box>
                    </Grid>
                </Grid>
            </Paper>
            <Paper>
                <Grid container spacing={1}>
                    <Grid item xs={6}>
                        <Typography variant="h6">Clear Pictures</Typography>
                        <Box>
                            <img src={DoClearImage} alt="do clear" />
                        </Box>
                    </Grid>
                    <Grid item xs={6}>
                        <Typography variant="h6">Blurry Pictures</Typography>
                        <Box>
                            <img src={DontBlurImage} alt="dont" />
                        </Box>
                    </Grid>
                </Grid>
            </Paper>
            <Paper>
                <Grid container spacing={1}>
                    <Grid item xs={6}>
                        <Typography variant="h6">Balanced Pictures Showcasing Your Activity or Branch</Typography>
                        <Box>
                            <img src={DoBalanceImage} alt="Do balanced" />
                        </Box>
                    </Grid>
                    <Grid item xs={6}>
                        <Typography variant="h6">Selfies</Typography>
                        <Box>
                            <img src={DontSelfieImage} alt="dont" />
                        </Box>
                    </Grid>
                </Grid>
            </Paper>
        </Box>

    )
}
